<!--赖传峰-->
<!--2022/1/24-->
<!--eslint-disable max-len-->
<template>
  <svg
    fill="none"
    height="64"
    viewBox="0 0 155 64"
    width="155"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M35.4485 20.2408C34.9695 20.1802 34.5625 19.8616 34.3885 19.4112L32.9484 15.6823C32.8292 15.3737 33.0824 15.0495 33.4107 15.0903L48.5667 16.9768C49.3455 17.0737 50.0128 17.5803 50.3154 18.3045L52 22.3354L35.4485 20.2408Z"
      fill="white"
      fill-rule="evenodd"
      opacity="0.985601"
    />
    <path
      clip-rule="evenodd"
      d="M28.5838 20.2408C29.0627 20.1802 29.4698 19.8616 29.6437 19.4112L31.0838 15.6823C31.203 15.3737 30.9498 15.0495 30.6215 15.0903L15.4655 16.9768C14.6867 17.0737 14.0194 17.5803 13.7168 18.3045L12.0322 22.3354L18.8878 21.4678L28.5838 20.2408Z"
      fill="white"
      fill-rule="evenodd"
      opacity="0.985601"
    />
    <path
      clip-rule="evenodd"
      d="M12 22.3354H52V44.3042C52 46.775 49.9971 48.7779 47.5263 48.7779H16.4737C14.0029 48.7779 12 46.775 12 44.3042V22.3354Z"
      fill="white"
      fill-rule="evenodd"
    />
    <path
      d="M27.5557 42.1113C27.5557 42.1113 29.7551 43.0002 31.9794 43.0002C34.2037 43.0002 36.4446 42.1113 36.4446 42.1113"
      stroke="#306EFF"
      stroke-linecap="round"
      stroke-width="2.23683"
    />
    <path
      d="M24.8885 31.0001V34.5556"
      stroke="#306EFF"
      stroke-linecap="round"
      stroke-width="3.57893"
    />
    <path
      d="M39.1111 31.0001V34.5556"
      stroke="#306EFF"
      stroke-linecap="round"
      stroke-width="3.57893"
    />
    <path
      d="M83.028 29.468C83.028 30.4387 82.794 31.3487 82.326 32.198C81.8753 33.0473 81.156 33.732 80.168 34.252C79.1973 34.772 77.9667 35.032 76.476 35.032H73.434V42H69.794V23.852H76.476C77.88 23.852 79.076 24.0947 80.064 24.58C81.052 25.0653 81.7887 25.7327 82.274 26.582C82.7767 27.4313 83.028 28.3933 83.028 29.468ZM76.32 32.094C77.3253 32.094 78.0707 31.8687 78.556 31.418C79.0413 30.95 79.284 30.3 79.284 29.468C79.284 27.7 78.296 26.816 76.32 26.816H73.434V32.094H76.32ZM87.4584 25.88C86.817 25.88 86.2797 25.6807 85.8464 25.282C85.4304 24.866 85.2224 24.3547 85.2224 23.748C85.2224 23.1413 85.4304 22.6387 85.8464 22.24C86.2797 21.824 86.817 21.616 87.4584 21.616C88.0997 21.616 88.6284 21.824 89.0444 22.24C89.4777 22.6387 89.6944 23.1413 89.6944 23.748C89.6944 24.3547 89.4777 24.866 89.0444 25.282C88.6284 25.6807 88.0997 25.88 87.4584 25.88ZM89.2524 27.596V42H85.6124V27.596H89.2524ZM101.377 42L96.4887 35.864V42H92.8487V22.76H96.4887V33.706L101.325 27.596H106.057L99.7127 34.824L106.109 42H101.377ZM121.266 29.468C121.266 30.4387 121.032 31.3487 120.564 32.198C120.114 33.0473 119.394 33.732 118.406 34.252C117.436 34.772 116.205 35.032 114.714 35.032H111.672V42H108.032V23.852H114.714C116.118 23.852 117.314 24.0947 118.302 24.58C119.29 25.0653 120.027 25.7327 120.512 26.582C121.015 27.4313 121.266 28.3933 121.266 29.468ZM114.558 32.094C115.564 32.094 116.309 31.8687 116.794 31.418C117.28 30.95 117.522 30.3 117.522 29.468C117.522 27.7 116.534 26.816 114.558 26.816H111.672V32.094H114.558ZM122.915 34.746C122.915 33.29 123.201 31.9987 123.773 30.872C124.362 29.7453 125.151 28.8787 126.139 28.272C127.144 27.6653 128.262 27.362 129.493 27.362C130.567 27.362 131.503 27.5787 132.301 28.012C133.115 28.4453 133.765 28.9913 134.251 29.65V27.596H137.917V42H134.251V39.894C133.783 40.57 133.133 41.1333 132.301 41.584C131.486 42.0173 130.541 42.234 129.467 42.234C128.253 42.234 127.144 41.922 126.139 41.298C125.151 40.674 124.362 39.7987 123.773 38.672C123.201 37.528 122.915 36.2193 122.915 34.746ZM134.251 34.798C134.251 33.914 134.077 33.16 133.731 32.536C133.384 31.8947 132.916 31.4093 132.327 31.08C131.737 30.7333 131.105 30.56 130.429 30.56C129.753 30.56 129.129 30.7247 128.557 31.054C127.985 31.3833 127.517 31.8687 127.153 32.51C126.806 33.134 126.633 33.8793 126.633 34.746C126.633 35.6127 126.806 36.3753 127.153 37.034C127.517 37.6753 127.985 38.1693 128.557 38.516C129.146 38.8627 129.77 39.036 130.429 39.036C131.105 39.036 131.737 38.8713 132.327 38.542C132.916 38.1953 133.384 37.71 133.731 37.086C134.077 36.4447 134.251 35.682 134.251 34.798ZM150 42L145.112 35.864V42H141.472V22.76H145.112V33.706L149.948 27.596H154.68L148.336 34.824L154.732 42H150Z"
      fill="white"
    />
  </svg>
</template>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

.logo-text {
  transition: display var(--transition-delay) var(--transition-animation);
}

.logo-svg {
  transition: width var(--transition-delay) var(--transition-animation);
  width: 138px;
  height: 56px;
}

@media screen and (max-width: 1200px) {
  .logo-text {
    display: none;
  }

  .logo-svg {
    width: 55px;
  }

}
</style>
